export default "__VITE_ASSET__CAidU3tn__"